module.exports = __webpack_public_path__ + "img/name.c941b1da.svg";